export default __webpack_public_path__ + "static/media/banner-mobile-nao-iniciado.f6adb72c.png";